import Vue from 'vue'
// 注册一个全局自定义指令 `v-focus`
export default (Vue) => {
    Vue.directive('toggleContent', {
        bind: function () {},
        inserted: function (el, binding) {
            if (binding.value) {
                let b = el.innerHTML;
                let tag = false;
                const textSize1 = 160;
                if (el.innerHTML.length > textSize1) {
                    tag = true;
                    let a = el.innerHTML.slice(0, textSize1);
                    el.innerHTML = '<span style="display:block;">' + a + '</span><span style="background:#fff;color:rgb(137,39,133);position:absolute;right:5px;bottom:0;">...&nbsp;&nbsp;&nbsp;全文</span>';
                } else {
                    return;
                }
                el.addEventListener('click', (e) => {
                    let a = b.slice(0, textSize1);
                    if (tag) {
                        tag = false;
                        el.innerHTML = b;
                    } else {
                        tag = true;
                        el.innerHTML = '<span style="display:block;">' + a + '</span><span style="background:#fff;color:rgb(137,39,133);position:absolute;right:5px;bottom:0;">...&nbsp;&nbsp;&nbsp;全文</span>';
                    }
                })
            } else {
                let b = el.innerHTML;
                let tag = false;

                const textSize2 = 100;

                if (el.innerHTML.length > textSize2) {
                    tag = true;
                    let a = el.innerHTML.slice(0, textSize2);
                    el.innerHTML = '<span style="position:relative;display:block;">' + a + '</span><span style="background:#fff;color:rgb(137,39,133);position:absolute;right:5px;bottom:0;">...&nbsp;&nbsp;&nbsp;全文</span>';
                } else {
                    return;
                }
                el.addEventListener('click', (e) => {
                    let a = b.slice(0, textSize2);
                    if (tag) {
                        tag = false;
                        el.innerHTML = b;
                    } else {
                        tag = true;
                        el.innerHTML = '<span style="position:relative;display:block;">' + a + '</span><span style="background:#fff;color:rgb(137,39,133);position:absolute;right:5px;bottom:0;">...&nbsp;&nbsp;&nbsp;全文</span>';
                    }

                })
            }

        },
        update: function () {},
        componentUpdated: function () {},
        unbind: function () {}
    })
}